export default "__VITE_ASSET__08359720__"